import dayjs from "dayjs";
import { Fragment } from "react";
import clsx from "clsx";
import { Link } from "@remix-run/react";
import type { MicroCMSAPIContentResponse, Topics } from "@/lib/microcms.server";

interface TopicsListProps {
  topics: MicroCMSAPIContentResponse<Topics>[];
}

export function TopicsList({ topics }: TopicsListProps) {
  return (
    <ul className="block">
      {topics.map((v, i) => (
        <Fragment key={v.id}>
          <li className={clsx("block", "mb-4", i !== 0 && ["pt-4", "border-t", "border-t-gray-200"])}>
            <Link
              to={`/topics/article/${v.id}`}
              aria-label={v.title}
              className={clsx("block", "hover:underline", "focus:underline")}
            >
              <div className={clsx("flex", "flex-col", "space-y-2")}>
                <div className="min-w-0">
                  <div className={clsx("text-xs", "font-bold", "leading-normal", "font-sans")}>
                    <div className={clsx("flex", "items-center", "space-x-1")}>
                      <div className="min-w-0">
                        <span className={clsx("block", "text-gray-700")}>
                          {dayjs(v.publishedAt).locale("ja").format("YYYY/M/D (dd)")}
                        </span>
                      </div>
                      <div className="min-w-0">
                        <span aria-hidden="true" className={clsx("block", "text-gray-700")}>
                          ・
                        </span>
                      </div>
                      <div className="min-w-0">
                        <span
                          className={clsx(
                            "block",
                            v.category[0] === "イベントレポート" && "text-brand-green",
                            v.category[0] === "お知らせ" && "text-brand-red"
                          )}
                        >
                          {v.category[0]}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="min-w-0">
                  <span className={clsx("block", "font-bold", "text-gray-900")}>{v.title}</span>
                </div>
              </div>
            </Link>
          </li>
        </Fragment>
      ))}
    </ul>
  );
}
